interface HeaderProps {
  title: string;
  onModeSwitch?: () => void;
  isJiraActive: boolean;
}

export default function Header({
  title,
  onModeSwitch,
  isJiraActive = false,
}: HeaderProps) {
  const activeClass =
    'rounded-md bg-white px-3 py-0.5 text-xs font-bold text-primary-700 shadow-sm cursor-default';
  const inactiveClass =
    'rounded-md px-3 py-0.5 text-xs font-medium text-gray-500 hover:text-gray-900 hover:bg-gray-200 cursor-pointer transition-colors';

  return (
    <div className="flex w-full items-center justify-between pb-2">
      <span className="font-extrabold text-primary-700">{title}</span>

      {onModeSwitch && (
        <div className="flex items-center gap-1 rounded-lg bg-gray-100 p-1">
          <button
            onClick={isJiraActive ? onModeSwitch : undefined}
            className={!isJiraActive ? activeClass : inactiveClass}
            disabled={!isJiraActive}
          >
            Aha!
          </button>
          <button
            onClick={!isJiraActive ? onModeSwitch : undefined}
            className={isJiraActive ? activeClass : inactiveClass}
            disabled={isJiraActive}
          >
            Jira
          </button>
        </div>
      )}
    </div>
  );
}
